export default __webpack_public_path__ + "static/media/Icon_Color.a8ffcce2.svg";